export default __webpack_public_path__ + "static/media/titletrimatra.395520d9.png";